<div style="height:0px">
    
    <span (window:beforeunload)="doBeforeUnload()"
          (window:unload)="doUnload()">
    </span>

    <span style="visibility: hidden;">
        <button type="button"
                class="btn btn-primary myBtnToOpenModal"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                data-bs-whatever="@mdo">Open modal</button>
    </span>

    <span class="modal fade"
          id="exampleModal"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true">

        <div class="modal-dialog">

            <div class="modal-content">

                <div class="modal-header">

                    <h5 class="modal-title"
                        id="exampleModalLabel">Unsaved data will be lost</h5>

                    <button type="button"
                            class="btn-close myBtnToCloseModal"
                            data-bs-dismiss="modal"
                            aria-label="Close">
                    </button>
                </div>

                <div class="modal-body">

                    <p>Are you sure you want to leave the page?</p>

                </div>

                <div class="modal-footer">

                    <button type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal"
                            (click)="leavePage($event)">Leave</button>

                    <button type="button"
                            class="btn btn-primary"
                            (click)="StayOnPage($event)">Stay</button>
                </div>

            </div>

        </div>

    </span>

</div>